module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 12 12",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }